import { COMMON_PAGE_LIMIT, prepareIdsForChunking } from '@wix/a11y-wizard-common';
import { queryCollections } from '@wix/ambassador-stores-catalog-v1-product/http';
export const fetchCategories = async (httpClient, errorHandler, ids) => {
  const {
    withErrorHandler
  } = errorHandler;
  const allCollections = [];
  await withErrorHandler(async () => {
    const idChunks = prepareIdsForChunking(ids, COMMON_PAGE_LIMIT);
    const chunkPromises = idChunks.map(async idChunk => {
      const chunkCollections = [];
      let offset = 0;
      let totalResults = 0;
      let itemsInPage = 0;
      do {
        const response = await httpClient.request(queryCollections({
          query: {
            filter: idChunk.length > 0 ? JSON.stringify({
              id: {
                $in: idChunk
              }
            }) : undefined,
            paging: {
              limit: COMMON_PAGE_LIMIT,
              offset
            }
          }
        }));
        const {
          collections,
          totalResults: total
        } = response.data;
        chunkCollections.push(...(collections ?? []));
        itemsInPage = (collections == null ? void 0 : collections.length) ?? 0;
        if (typeof total === 'number') {
          totalResults = total;
        }
        offset += COMMON_PAGE_LIMIT;
      } while (offset < totalResults && itemsInPage > 0);
      return chunkCollections;
    });
    const results = await Promise.all(chunkPromises);
    allCollections.push(...results.flat());
  }, {
    errorCodesMap: {}
  });
  return allCollections;
};
//# sourceMappingURL=fetch-categories.js.map